function closeInstaPopup() {
    document.getElementById('insta-popup').style.display = 'none';
  }

  function openInstaPopup() {
    document.getElementById('insta-popup').style.display = 'flex';
  }

  window.addEventListener('load', () => {
    setTimeout(() => {
      openInstaPopup();
    }, 1000);
  });

